export default __webpack_public_path__ + "static/media/shape2.ae306ad0.png";